import Cookies from 'js-cookie';
import { jwtDecode } from 'jwt-decode';
import { call, put, takeLatest, all } from 'redux-saga/effects';

import { addAPIError, removeAPIError } from 'redux/apiErrors/sagas';
import {
  CLUB_MEMBERSHIP_REQUESTING,
  RESET_CLUB_MEMBERSHIP_ISFETCHING,
  GET_CLUB_MEMBERSHIP_SUCCESS
} from 'redux/clubMemberships/constants';
import { getO as getOrder } from 'redux/orders/sagas';

import {
  addClubShipmentItem,
  exchangeClubShipmentItem,
  editClubShipmentItem,
  deleteClubShipmentItem,
  shipShipmentNow,
  skipClubShipment,
  unskipClubShipment
} from './api';
import {
  ADD_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  EXCHANGE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  EDIT_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  DELETE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST,
  PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST,
  SKIP_CLUB_MEMBER_SHIPMENT_REQUEST,
  UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST,
  GET_CLUB_MEMBER_SHIPMENT_SUCCESS
} from './constants';

export function* addItem(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      addClubShipmentItem,
      customerId(),
      action.clubMemberShipmentId,
      action.item
    );
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.errorFunction) {
      action.errorFunction();
    }
  }
}

export function* exchangeItem(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      exchangeClubShipmentItem,
      customerId(),
      action.clubMemberShipmentId,
      action.productVariantId,
      action.item
    );
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
      payload: response.data
    });
    action.successFunction(response.data);
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.errorFunction) {
      action.errorFunction();
    }
  }
}

export function* editItem(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      editClubShipmentItem,
      customerId(),
      action.clubMemberShipmentId,
      action.productVariantId,
      action.item
    );
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
      payload: response.data
    });
    if (action.successFunction) {
      action.successFunction();
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.errorFunction) {
      action.errorFunction();
    }
  }
}

export function* deleteItem(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      deleteClubShipmentItem,
      customerId(),
      action.clubMemberShipmentId,
      action.productVariantId
    );
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
      payload: response.data
    });
    if (action.successFunction) {
      action.successFunction();
    }
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
    if (action.errorFunction) {
      action.errorFunction();
    }
  }
}

export function* shipNow(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      shipShipmentNow,
      customerId(),
      action.clubMemberShipmentId
    );
    yield call(getOrder, { orderId: response.data.orderId });
    if (action.successFunction) {
      action.successFunction(response.data);
    }
    yield put({
      type: GET_CLUB_MEMBERSHIP_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* skip(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      skipClubShipment,
      customerId(),
      action.clubMemberShipmentId
    );
    if (action.successFunction) {
      action.successFunction(response.data);
    }
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* unskip(action) {
  try {
    yield call(removeAPIError);
    yield put({ type: CLUB_MEMBERSHIP_REQUESTING });
    const response = yield call(
      unskipClubShipment,
      customerId(),
      action.clubMemberShipmentId
    );
    if (action.successFunction) {
      action.successFunction(response.data);
    }
    yield put({
      type: GET_CLUB_MEMBER_SHIPMENT_SUCCESS,
      payload: response.data
    });
  } catch (error) {
    yield put({ type: RESET_CLUB_MEMBERSHIP_ISFETCHING });
    yield call(addAPIError, error);
  }
}

export function* watchList() {
  yield takeLatest(ADD_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST, addItem);
  yield takeLatest(EXCHANGE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST, exchangeItem);
  yield takeLatest(EDIT_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST, editItem);
  yield takeLatest(DELETE_CLUB_MEMBER_SHIPMENT_ITEM_REQUEST, deleteItem);
  yield takeLatest(PROCESS_CLUB_MEMBER_SHIPMENT_REQUEST, shipNow);
  yield takeLatest(SKIP_CLUB_MEMBER_SHIPMENT_REQUEST, skip);
  yield takeLatest(UNSKIP_CLUB_MEMBER_SHIPMENT_REQUEST, unskip);
}

export default function* clubMembershipSagas() {
  yield all([watchList()]);
}

const customerId = () => jwtDecode(Cookies.get('customerToken')).sub;
